var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3"},[(!_vm.isAuthenticated)?_c('Login',{on:{"logged-in":_vm.loggedIn}}):_c('PlanningList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }